import { action, atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'

import * as TopbarMode from '../model/topbar-mode'

export const topbarModeAtom = atom<TopbarMode.TopbarMode>(
  TopbarMode.TopbarMode.Trending,
  'topbarModeAtom',
).pipe(withLocalStorage(`${STORAGE_PREFIX}/topbarMode`))

const topbarPauseCountAtom = atom(0, 'topbarPauseCountAtom')

export const topbarPausedAtom = atom(
  (ctx) => ctx.spy(topbarPauseCountAtom) > 0,
  'topbarPausedAtom',
)

export const registerTopbarPauseAction = action((ctx, register: boolean) => {
  const current = ctx.get(topbarPauseCountAtom)
  topbarPauseCountAtom(ctx, register ? current + 1 : Math.max(0, current - 1))
}, 'registerTopbarPauseAction')
